// import

import {isServer} from '@sitearcade/is-env';
import {createGlobalStyles as createGlobalStyle} from 'goober/global';
import Head from 'next/head';
import {useState, useEffect} from 'react';

// types

declare global {
  interface Window {
    grecaptcha?: {
      ready: (onReady: () => void) => void;
      execute: () => Promise<string>;
    };
  }
}

// vars

const siteKey = process.env.RECAPTCHA_CLIENT_KEY;

// fns

// INFO: https://developers.google.com/recaptcha/intro
export async function recaptcha(): Promise<string> {
  return new Promise((resolve, reject) => {
    if (isServer) {
      return reject(new Error('Cannot run recaptcha on server!'));
    }

    window.grecaptcha?.ready(() => (
      // @ts-expect-error window.grecaptcha exists here...
      resolve(window.grecaptcha.execute())
    ));
  });
}

// components

export function RecaptchaScript() {
  const [tag, setTag] = useState<JSX.Element | null>(null);

  useEffect(() => setTag(
    <script async defer src={`https://www.google.com/recaptcha/api.js?render=${siteKey}`} />,
  ), []);

  return (
    <>
      <Head>
        <link href="https://www.google.com" rel="preconnect" />
        {tag}
      </Head>

      <HideRecaptcha />

      <div
        className="g-recaptcha"
        data-badge="inline"
        data-sitekey={siteKey}
        data-size="invisible"
        id="recaptcha"
        style={{display: 'none', visibility: 'hidden'}}
      />
    </>
  );
}

// styles

const HideRecaptcha = createGlobalStyle`
  .grecaptcha-badge {
    display: none !important;
    right: -1000px !important;
  }
`;
